// stockUtils.js

import { API_ENDPOINTS } from "../../config/api/apiCall";
import { callApi } from "../../utils/apiClient";


export const fetchStockAndUpdateInventory = (parameter) => {
    return new Promise((resolve, reject) => {
        callApi(API_ENDPOINTS.FG_get_Stock_RelatedDetails_ForUpdate_FinishedGoods, 'POST', { 'Content-Type': 'application/json' }, parameter)
            .then(data => {
                if (data && data.length > 0) {
                    const today = new Date().toLocaleDateString();

                    let localFinishedGoodsReelBundleList = [
                        {
                            ReelBundleNumber: data[0].cr_number,
                            ReelBundleWeight: parseFloat(data[0].achieved_qty), // Keep it as a number //reel , bundle weight
                            ProductId: parseInt(data[0].product_id)
                        }
                    ];

                    const requestBody = {
                        ProductID: data[0].product_id,
                        StockLedgerID: 0,
                        AllocatedOrderId: data[0].confirmation_id,
                        AllocatedOrderNo: data[0].indent_no,
                        LocationId: parameter.p_location_id,
                        UOM: 'Kg',
                        PackageMode: 'Reel', //bundle
                        NoOfSheets: 0, //need from production from per ream
                        ReamWeight: 0, //need from production
                        PacketsPerBundle: 0, //no of reams per bundle production
                        NoOfBundles: 0, //1
                        ReelOD: data[0].diameter,//0
                        CoreID: data[0].inner_core,//0
                        NoOfReels: 1, //0
                        LotNo: data[0].lot_no,
                        ProducedQty: 0,
                        ProductionDate: today,
                        Remarks: '',
                        TransactionType: 'ManufacturedOrderItemIn',
                        FinishedGoodsReelBundleList: localFinishedGoodsReelBundleList,
                        filter: {
                            COMPANY_FINANCIAL_YEAR_ID: 1,
                            COMPANY_ID: 1,
                        },
                    };

                    callApi(API_ENDPOINTS.updateProductionQtyToInventory, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                        .then(data => {
                            if (data && data.length > 0) {
                                resolve(); // Resolve when successful
                            } else {
                                reject(new Error('Failed to update inventory'));
                            }
                        })
                        .catch(error => {
                            reject(error); // Reject the promise on error
                        });
                } else {
                    reject(new Error('No stock-related details found'));
                }
            })
            .catch(error => {
                reject(error); // Reject the promise on error
            });
    });
};
